var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViolation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "z02_\u9884\u8B66\u7BA1\u7406") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.9,50.1H50.1a2.46,2.46,0,0,0,2.47-2.47V26.24a20.57,20.57,0,0,0-41.14,0V47.63A2.46,2.46,0,0,0,13.9,50.1Zm2.47-23.86A15.63,15.63,0,0,1,32,10.61h.71A15.63,15.63,0,0,1,47.63,26.24V45.17H16.37Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.22,53.39H9.78a2.19,2.19,0,0,0-2.47,2.47,2.18,2.18,0,0,0,2.47,2.47H54.22a2.18,2.18,0,0,0,2.47-2.47A2.19,2.19,0,0,0,54.22,53.39Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.47,27.89H31l4.58-7.38.17-.33a2.47,2.47,0,0,0-4.37-2.28h0L24.43,29.05l-.15.3a2.36,2.36,0,0,0-.22,1,2.48,2.48,0,0,0,2.47,2.47H32l-4.37,5-.22.3a2.47,2.47,0,0,0,3.92,3l8-9,.21-.27A2.47,2.47,0,0,0,37.47,27.89Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViolation);
export default __webpack_public_path__ + "static/media/Violation.bc8237aa.svg";
export { ForwardRef as ReactComponent };